/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 36, height = 36 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 44V23.9l-.7-.7c-.367-.367-.625-.75-.775-1.15-.15-.4-.225-.833-.225-1.3 0-.467.075-.908.225-1.325.15-.417.408-.808.775-1.175l6.4-6.45h9L32.5 4l3.75 3.75a12.78 12.78 0 0 1 2.925 4.475c.65 1.683.992 3.375 1.025 5.075-.033 1.7-.375 3.392-1.025 5.075a12.78 12.78 0 0 1-2.925 4.475L32 31.1V44H10Zm3-3h16V29.85l5.1-5.1c1.033-1.033 1.808-2.192 2.325-3.475A10.55 10.55 0 0 0 37.2 17.3c0-1.367-.258-2.683-.775-3.95-.517-1.267-1.292-2.417-2.325-3.45l-1.6-1.65-6.55 6.55h-9l-1.65 1.65 3.7 3.7c.933.933 1.633 1.975 2.1 3.125.467 1.15.7 2.342.7 3.575 0 1.167-.2 2.3-.6 3.4-.4 1.1-1.017 2.1-1.85 3L13 26.9V41Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgComponent;
